<template>
  <div style="width: 80%">
    <el-form :model="form" label-width="auto" style="max-width: 600px">
      <el-form-item label="文件内容">
        <el-input v-model="form.content" />
      </el-form-item>
      <el-form-item label="key">
        <el-input v-model="form.key" />
      </el-form-item>

      <el-upload v-model:file-list="fileList" action="ok" :auto-upload="false" list-type="picture-card"
        :on-preview="handlePictureCardPreview" :on-remove="handleRemove" multiple>
        <el-icon>
          添加
          <Plus />
        </el-icon>
      </el-upload>

      <el-dialog v-model="dialogVisible">
        <img w-full :src="dialogImageUrl" alt="Preview Image" />
      </el-dialog>
      <el-form-item style="margin:10px;">
        <el-button type="primary" @click="onSubmit">新增</el-button>
      </el-form-item>
    </el-form>

    <div>{{ uploadUrl }}</div>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import axios from "axios";
import { ElLoading, ElMessage } from "element-plus";
import { inject } from 'vue'

const dialogImageUrl = ref("");
const dialogVisible = ref(false);

var form = reactive({
  content: "",
  key: "",
});

export default {
  name: "UploadFileView",
  data() {
    return {
      serverUrl: inject('serverUrl'),
      form,
      dialogImageUrl,
      dialogVisible,
      fileList: [],
      fileListOut: [],
      uploadUrl: "",
    };
  },
  methods: {
    async onSubmit() {
      var that = this;

      console.log("submit!");
      //console.log(this.form);
      if (this.fileList.length == 0) {
        return ElMessage({
          message: "请先上传图片！",
          grouping: true,
          type: "warning",
        });
      }
      if (this.form.content.length == 0 || this.form.key.length == 0) {
        return ElMessage({
          message: "必填项不能为空！",
          grouping: true,
          type: "warning",
        });
      }
      //console.log("fileList:", this.fileList);
      const loadingInstance = ElLoading.service({ fullscreen: true });
      await this.upaction(); // 等待上传图片完成
      // console.log("我的上传图片的真实路径", this.fileList);
      //console.log("最后上传的图片", this.fileListOut);
      for (var i = 0; i < this.fileListOut.length; i++) {
        this.uploadUrl = this.uploadUrl + " " + this.fileListOut[i];
      }
      //console.log("输出文本", this.uploadUrl);
      loadingInstance.close();
    },
    handlePictureCardPreview(uploadFile) {
      //console.log(uploadFile);
      this.dialogImageUrl = uploadFile.url;
      this.dialogVisible = true;
    },

    handleRemove(file, fileList) {
      //console.log(file);
      //console.log(fileList);
    },

    // 上传图片
    async upaction() {
      var that = this;
      for (let i = 0; i < this.fileList.length; i++) {
        var src = await this.uploadFile(this.fileList[i]);
        this.fileListOut.push(src);
      }
    },
    base64ToBlob(base64Data, contentType = "") {
      const byteCharacters = atob(base64Data);
      const byteArrays = [];
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i));
      }
      return new Blob([new Uint8Array(byteArrays)], { type: contentType });
    },

    async uploadFile(file) {
      /*
      console.log("uploadFile中，未编码url为", file.url);
      const newbasesrc = await this.getdata(file);
      console.log("编码url后", newbasesrc);
*/
      const formData = new FormData();
      //const fileBlob = this.base64ToBlob(newbasesrc.split(",")[1], "image/png");

      // ✅ 正确：使用 fileBlob，并指定文件名（可选）
      formData.append("file", file.raw);
      formData.append("content", this.form.content);
      formData.append("fileName", file.name);
      formData.append("fileExtension", file.name.split('.')[1]);
      formData.append("fileType", file.raw.type);
      formData.append("fileSize", file.raw.size);
      try {
        const res = await axios.post(
          this.serverUrl + "/api/upload/file", // 请求后端的 URL
          //{ file: newbasesrc },
          formData,
          {
            headers: {
              //apikey: "37A3285C065822FA75B791F14AC9AE40",
              apikey: this.form.key,
              //"Content-Type": "multipart/form-data;charset=utf-8",
            },
          }
        );
        console.log(res);
        if (res.data.code == 'fail') {

          ElMessage({
            type: 'error',
            message: '错误' + res.data.msg,
          })

          return '';
        }

        ElMessage({
          message: file.name + "上传成功！",
          grouping: true,
          type: "success",
        });

        return res.data.obj.fileUrl;
        //console.log(res);
      } catch (error) {
        console.error("代理请求失败:", error);
      }
      return "";
    },
    async getdata(file) {
      // 使用 FileReader 将文件转换为 base64 编码字符串
      console.log("getdata函数中，准备转化", file);
      const base64String = await this.readFileAsBase64(file);
      console.log("获得编码", base64String);
      return base64String;
    },

    readFileAsBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          // 将文件转换为 base64 编码
          const base64String = event.target.result;
          resolve(base64String);
        };
        reader.onerror = reject;
        // 读取文件内容并转换为 base64 编码字符串
        reader.readAsDataURL(file.raw);
      });
    },
  },
};
</script>
